'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _tabbable = require('tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _2 = require('..');

require('../styles/DropdownMenu.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  handleSelect: _react2.default.PropTypes.func,
  children: _react2.default.PropTypes.array,
  options: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _reactImmutableProptypes2.default.list]),
  right: _react2.default.PropTypes.bool,
  closeAndFocus: _react2.default.PropTypes.func
};

var ARROW_UP = 'ArrowUp';
var ARROW_DOWN = 'ArrowDown';
var TAB = 'Tab';

var DropdownMenu = function (_BcReactComponent) {
  _inherits(DropdownMenu, _BcReactComponent);

  function DropdownMenu(props) {
    _classCallCheck(this, DropdownMenu);

    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

    _this.state = {
      focusedValue: null
    };
    _this.items = [];
    _this.bindAll('renderItem', 'handleKeyDown');
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      var tabbableElements = (0, _tabbable2.default)(this._dropdownmenu);
      if ([ARROW_DOWN, ARROW_UP, TAB].indexOf(e.key) !== -1) {
        var moveUp = e.key === ARROW_UP || e.key === TAB && e.shiftKey;
        var focusedIndex = _lodash2.default.findIndex(tabbableElements, function (item) {
          return item === document.activeElement;
        });
        var moveIndex = moveUp ? -1 : 1;
        var nextItem = tabbableElements[focusedIndex + moveIndex];

        if (!nextItem) {
          if (e.key === TAB && typeof this.props.closeAndFocus === 'function') {
            e.preventDefault();
            this.props.closeAndFocus();
          }
          return;
        }
        e.preventDefault();
        document.activeElement.blur();
        nextItem.focus();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var tabbableElements = (0, _tabbable2.default)(this._dropdownmenu);
      if (tabbableElements.length > 0) {
        this._dropdownmenu.addEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // remove listener for keydown on the document
      if (this._dropdownmenu) {
        this._dropdownmenu.removeEventListener('keydown', this.handleKeyDown);
      }
      this._dropdownmenu = null;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item) {
      var _this2 = this;

      var handleSelect = function handleSelect(event) {
        event.preventDefault();
        _this2.props.handleSelect(item);
      };

      return _react2.default.createElement(
        _2.DropdownMenuItem,
        { key: item.key || item.value },
        _react2.default.createElement(
          'a',
          {
            href: '#menu-item-' + item.value,
            'data-test-id': 'dropdown-item-' + item.value,
            onClick: handleSelect },
          item.label
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var menuClasses = (0, _classnames2.default)('cp-dropdown-menu', 'dropdown-menu', { 'dropdown-menu-right': this.props.right });

      return _react2.default.createElement(
        'ul',
        { id: this.props.id, className: menuClasses, style: { display: 'block' }, ref: function ref(el) {
            _this3._dropdownmenu = el;
          } },
        this.props.children ? this.props.children : this.props.options.map(this.renderItem)
      );
    }
  }]);

  return DropdownMenu;
}(_baseBcReactComponent2.default);

DropdownMenu.propTypes = propTypes;

exports.default = DropdownMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-menu/components/DropdownMenu.component.js
// module id = 624
// module chunks = 0 1 9 10 11